<template>
    <SectionViewLayout
      title='settings.forwarding.title'
      :content_state='messages_forwarding_controller.content_state'
      content_class="messages-options"
      close_route="settings"
      >
        <template #actions>
            <ActionButton v-if="AccountController.account.premium.enabled"
                @click='save()'
                icon="fas fa-save"
                :loading=messages_forwarding_controller.content_state.saving
                v-tooltip='"global.actions.save_changes"'
                :gtm="{
                    module : 'forward_settings',
                    feature: 'forward_list',
                    block  : `top_actions`,
                    action : 'submit'
                }"
            />
        </template>

        <template #content>
            <fieldset v-if="AccountController.account.premium.upgrade">
                <PremiumSubscribe
                    text="premium.forwarding_disabled"
                    :gtm="{
                        module : 'forward_settings',
                        feature: 'forward_list',
                        block  : 'pre_content',
                        action : 'premium_subscribe'
                    }"
                />
            </fieldset>

            <form v-else>

                <fieldset>
                    <legend>{{ Language.say('settings.forwarding.labels.forwarding_settings') }}</legend>

                    <p>
                        {{ Language.say('settings.forwarding.content.info') }}
                    </p>
                </fieldset>

                <fieldset>
                    <InputCheckbox
                        input_id="mf_ck_01"
                        :input_disabled="!AccountController.account.premium.enabled"
                        :label_text="Language.say('settings.forwarding.labels.enable_forwarding')"
                        input_name="forward_messages"
                        :true_value="1"
                        :false_value="0"
                        v-model:input_value="messages_forwarding_controller.item.forward_enabled"
                        >
                    </InputCheckbox>

                    <InputCheckbox
                        input_id="mf_ck_02"
                        :input_disabled="!AccountController.account.premium.enabled || !messages_forwarding_controller.item.forward_enabled"
                        :label_text="Language.say('settings.forwarding.labels.keep_copy')"
                        input_name="forward_messages"
                        :true_value="1"
                        :false_value="0"
                        v-model:input_value="messages_forwarding_controller.item.keep_local_copy"
                        >
                    </InputCheckbox>

                    <ContainerAlert v-if="!messages_forwarding_controller.item.keep_local_copy"
                        type="warning"
                    >
                        {{ Language.say('settings.forwarding.notices.local_copy') }}
                    </ContainerAlert>

                    <fieldset>
                        <InputText v-for="(address, key, index) in messages_forwarding_controller.item.forward_emails" :key="key"
                            :input_id="`mf_address_${key}`"
                            :input_name="key"
                            :input_disabled="!AccountController.account.premium.enabled || !messages_forwarding_controller.item.forward_enabled"
                            :input_invalids="properties_validation.invalid"
                            :input_value="address"
                            v-model:input_value="messages_forwarding_controller.item.forward_emails[key]"
                            :label_text="(index === 0) ? 'settings.forwarding.labels.add_address' : 'settings.forwarding.labels.add_address_additional'"
                            error_text="contacts.form.error_email"
                            >
                        </InputText>
                    </fieldset>
                </fieldset>

                <div class="submit-desktop" v-if="AccountController.account.premium.enabled">
                    <ActionButton
                        @click='save()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.save_changes"
                        :loading="messages_forwarding_controller.content_state.saving"
                        :gtm="{
                            module : 'forward_settings',
                            feature: 'forward_list',
                            block  : 'bottom_actions',
                            action : 'submit'
                        }"
                        />
                </div>
            </form>
        </template>
    </SectionViewLayout>
</template>

<script setup>
    import { reactive, onBeforeMount }  from 'vue';
    import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
    import SectionViewLayout            from '@/vue/Layouts/Sections/SectionViewLayout.vue';
    import MessagesForwardingController from '@/js/Settings/MessagesForwarding/MessagesForwardingController.js';
    import Language                     from '@/js/Shared/Language/Language.js';
    import InputCheckbox                from '@/vue/Elements/Inputs/InputCheckbox.vue';
    import AccountController            from '@/js/Webmail/AccountController';
    import InputText                    from '@/vue/Elements/Inputs/InputText.vue';
    import PropertiesValidation         from '@/js/Shared/Validation/PropertiesValidation';
    import PremiumSubscribe             from '../../Webmail/Partials/Premium/PremiumSubscribe.vue';
import ContainerAlert from '@/vue/Elements/Content/ContainerAlert.vue';

    const messages_forwarding_controller = reactive(MessagesForwardingController);
    const properties_validation          = reactive(new PropertiesValidation());

    onBeforeMount(async () => {
        await fetchOptions();
        setPropertiesValidationRules();
    })

    const fetchOptions = async () => {
        await messages_forwarding_controller.fetchForwards()
    }

    const save = async () => {
        if (validateProperties() === false) {
            return;
        }

        if (await messages_forwarding_controller.saveForwards() === false) {
            return;
        }

        setPropertiesValidationRules();
    }

    const setPropertiesValidationRules = () => {
        let rules = {};

        for (let key in messages_forwarding_controller.item.forward_emails) {
            rules[key] = {
                regex: 'email',
            };
        }

        properties_validation.reset();
        properties_validation.setRules(rules);
    };

    const validateProperties = () => {
        properties_validation.rules['forward_email_0']['required'] = messages_forwarding_controller.item.forward_enabled;
        return properties_validation.validateObject(messages_forwarding_controller.item.forward_emails);
    };

    messages_forwarding_controller.content_state.onErrorRetry(async () => {
        await fetchOptions();
    })

</script>